/* eslint-disable react/prop-types */
import { Box, Switch, Typography } from "@mui/material";
import React from "react";

const SwitchBox = ({ checked, label, sx, ...rest }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        ...sx,
      }}
    >
      <Switch checked={checked} {...rest} />
      <Typography variant="subtitle1" fontSize={14}>
        {label}
      </Typography>
    </Box>
  );
};

export default SwitchBox;
